import { render, staticRenderFns } from "./MasterPage.vue?vue&type=template&id=b54ba7b8&scoped=true"
import script from "./MasterPage.vue?vue&type=script&lang=ts"
export * from "./MasterPage.vue?vue&type=script&lang=ts"
import style0 from "./MasterPage.vue?vue&type=style&index=0&id=b54ba7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54ba7b8",
  null
  
)

export default component.exports